import React from 'react';
import BookCoverImage from './BookCoverImage';

export default function BookCaseImage({ src, alt = '', className, onClick }) {
  return (
    <BookCoverImage
      src={src}
      alt={alt}
      className={className}
      onClick={onClick}
      width={88}
      height={128}
      fontSize={11}
    />
  );
}
